import type { Client } from '../../api/client.js';

/** Ligne de la liste des dossiers : `DossierSummary` du contrat (dossiers.lister). */
export interface LigneDossier {
  id: string;
  reference: string;
  title: string;
  status: 'prospect' | 'actif' | 'bloque' | 'clos' | 'abandonne';
  currentPhase: string;
  blocker: { kind: string; label: string; since: string } | null;
  estimatedValue: unknown;
  etudeName: string | null;
  heirsCount: number;
  respondedCount: number;
  toFollowUpCount: number;
  unreachableCount: number;
}

export interface PageDossiers {
  items: LigneDossier[];
  nextCursor: string | null;
}

export interface DossierCree {
  id: string;
  title: string;
  reference: string;
}

export interface SourceDossiers {
  lister(curseur?: string): Promise<PageDossiers>;
  /** `venuPar` : réponse à « Qui est venu vous voir ? » (code de la donnée versionnée), null sans réponse. */
  creer(titre: string, venuPar?: string | null): Promise<DossierCree>;
}

const TAILLE_PAGE = '100';

/**
 * Lecture et création des dossiers par les routes du contrat, rien d'autre. Le mandant et l'étude ne sont pas
 * demandés à la création : le mandat se signe ensuite au dossier, et la garde RG-01 (aucune recherche d'héritier
 * sans mandat signé) reste celle du serveur.
 */
export function creerSourceDossiers(client: Client): SourceDossiers {
  return {
    lister: (curseur) =>
      client.appeler<PageDossiers>('dossiers.lister', { requete: { limit: TAILLE_PAGE, ...(curseur ? { cursor: curseur } : {}) } }),
    creer: (titre, venuPar) =>
      client.appeler<DossierCree>('dossiers.creer', {
        corps: { title: titre.trim(), mandantPersonId: null, etudeId: null, ...(venuPar ? { venuPar } : {}) },
      }),
  };
}
